import { render, staticRenderFns } from "./RecognitionComposer.vue?vue&type=template&id=48660a00"
import script from "./RecognitionComposer.vue?vue&type=script&lang=js"
export * from "./RecognitionComposer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports